import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation } from 'react-query';

export interface ICreateSpotlightParams {
  script: string;
  backgroundId: string;
}

export interface ICreateSpotlightResponse {
  videoId: number;
}

export const createSpotlight = async (
  params: ICreateSpotlightParams
): Promise<ICreateSpotlightResponse> => {
  const response = await EXPRESS_API.post('/quick-videos/spotlight', params);
  return response.data;
};

export const useCreateSpotlightMutation = (
  onSuccess?: (uploadedVideoId: number) => void
) => {
  const { showError } = useToastError();

  return useMutation(createSpotlight, {
    onSuccess: async res => {
      onSuccess?.(res.videoId);
      successToast({
        title: `Spotlight has been successfully created!`,
      });
    },
    onError: error =>
      showError(
        error || `An error occurred while trying to create the spotlight.`
      ),
  });
};
